<template>
  <div>
    <!-- LOGIN FORM//S -->
    <div class="well">
      <div class="certification-row">
        <div class="cert-title en-small">
          {{ $t("mypage.verify.emailVerification") }}
        </div>
        <div>{{ email || "-" }}</div>
        <div class="input-area">
          <button
            v-if="emailConfirm"
            v-bind:class="{ 'btn-agree-view': true, completed: emailConfirm }"
          >
            {{ $t("mypage.modify.completeVerify") }}
          </button>
          <button
            v-else
            v-bind:class="{ 'btn-agree-view': true, completed: emailConfirm }"
          >
            {{ $t("mypage.modify.verify") }}
          </button>
        </div>
      </div>
      <div class="certification-row">
        <div class="cert-title en-small">
          {{ $t("mypage.verify.IDVerification") }}
        </div>
        <div>{{ phone || "-" }}</div>
        <div class="input-area">
          <button
            v-if="userConfirm"
            v-bind:class="{ 'btn-agree-view': true, 're-cert': userConfirm }"
            @click="authPhone"
          >
            {{ $t("mypage.modify.completeVerify") }}
          </button>
          <button
            v-else
            v-bind:class="{ 'btn-agree-view': true, 're-cert': userConfirm }"
            @click="authPhone"
          >
            {{ $t("mypage.modify.verify") }}
          </button>
        </div>
      </div>
      <div class="certification-row" flex fjs fic>
        <div class="cert-title en-small">
          {{ $t("mypage.verify.bankAccount") }}
        </div>
        <div class="data-box">
          <div>{{ `${bankName}-${accountNumber}` || "-" }}</div>
          <div class="input-area">
            <p>
              <span v-if="bankConfirm">[{{ bankName || "" }}]</span>
              {{ accountNumber || "" }}
            </p>
          </div>
        </div>
        <button
          v-if="bankConfirm"
          v-bind:class="{
            'bank-btn': true,
            'btn-agree-view': true,
            'cert-cancel': bankConfirm,
          }"
          @click="accountAuth"
        >
          {{ $t("mypage.modify.completeVerify") }}
        </button>
        <button
          v-else
          v-bind:class="{
            'bank-btn': true,
            'btn-agree-view': true,
            'cert-cancel': bankConfirm,
          }"
          @click="accountAuth"
        >
          {{ $t("mypage.modify.verify") }}
        </button>
      </div>
      <div class="certification-row">
        <div class="cert-title">{{ $t("mypage.verify.OTPRegister") }}</div>
        <div>{{ otpDate || "-" }}</div>
        <div class="input-area">
          <button
            v-if="otpConfirm"
            v-bind:class="{ 'btn-agree-view': true, 'cert-cancel': otpConfirm }"
            @click="otpUpdate"
          >
            {{ $t("mypage.modify.completeVerify") }}
          </button>
          <button
            v-else
            v-bind:class="{ 'btn-agree-view': true, 'cert-cancel': otpConfirm }"
            @click="otpUpdate"
          >
            {{ $t("mypage.modify.verify") }}
          </button>
        </div>
      </div>
      <div class="certification-row">
        <div class="cert-title">{{ $t("mypage.verify.proofOfResidence") }}</div>
        <div>
          {{
            authResidence === "E"
              ? userInfo.authInfo.mpAltertime ||
                userInfo.authInfo.mpRegtime ||
                "-"
              : "-"
          }}
        </div>
        <div class="input-area">
          <button
            v-if="authResidence"
            v-bind:class="{
              'btn-agree-view': true,
              completed: residenceConfirm && authResidence === 'E',
            }"
            @click="residence"
          >
            {{ $t("mypage.modify.completeVerify") }}
          </button>
          <button
            v-else
            v-bind:class="{
              'btn-agree-view': true,
              completed: residenceConfirm && authResidence === 'E',
            }"
            @click="residence"
          >
            {{ $t("mypage.modify.verify") }}
          </button>
        </div>
      </div>
    </div>
    <!-- 필수 인증 안내//S -->
    <vs-popup title="필수 인증 안내" :active.sync="necessaryCertifiaction">
      <p class="text-center">
        먼저 [미완료 인증 절차 : 예, 본인인증]을 완료하세요.
      </p>
      <vs-button
        color="primary"
        @click="necessaryCertifiaction = false"
        class="btn-block custom"
        type="filled"
        >확인</vs-button
      >
    </vs-popup>
    <!-- 필수 인증 안내//E -->
    <!-- OTP 인증 해지//S -->
    <vs-popup :title="$t('otpCancel.title')" :active.sync="removeOTPModal">
      <p class="text-center">
        <span v-html="$t('otpCancel.content[0]')"></span>
        <br />
        <span v-html="$t('otpCancel.content[1]')"></span>
        <br />
        <br />
        <span v-html="$t('otpCancel.content[2]')"></span>
        <br />
        <br />
        {{ $t("verificationReset.24hSecurityPolicy") }}
        <br />
        <br />
        {{ $t("otpCancel.content[3]") }}
        <vs-input
          type="text"
          pattern="[0-9]*"
          inputmode="decimal"
          class="input-otp"
          :placeholder="$t('otp.sixDigits')"
          v-model="otpNumber"
        ></vs-input>
        <br />
        {{ $t("otpCancel.content[4]") }}
      </p>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click="removeOTPModal = false"
            class="btn-block custom"
            type="filled"
            >{{ this.$t("confirm.cancel") }}</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click="otpDelete"
            class="btn-block custom"
            type="filled"
            >{{ this.$t("confirm.ok") }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- OTP 인증 해지//E -->

    <!-- POPUP 계좌등록 안내//S -->
    <vs-popup title="계좌 등록 안내" :active.sync="popupAccountGuide">
      <div class="well well-black">
        FLYBIT에서는 유진투자증권 계좌만 등록할 수 있습니다.
        <br />유진투자증권 계좌 없으신 분은 계좌 개설 하여 주시기 바랍니다.
      </div>
      <h3>유진투자증권 개좌 개설 방법</h3>
      <h4>1.홈페이지 안내보기</h4>
      <p>
        <vs-button
          color="#b5b5b5"
          size="small"
          onclick="window.open('https://www.eugenefn.com/serv/svoa/svoa499r.do', '_blank')"
          >바로가기</vs-button
        >
      </p>
      <h4>2.계좌개설 APP 다운로드 SMS 전송 받기</h4>
      <p>
        <vs-button color="#b5b5b5" size="small" @click="doAppDnSms"
          >설치SMS 전송</vs-button
        >
        <br />QR 코드로 계좌개설 APP 설치하기
      </p>
      <h4>3.개설 후 FLYBIT에 계좌 등록 하기</h4>
      <p>※ 계좌 개설 문의 : 유진투자증권 고객센터 1588-6300</p>

      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
          <vs-button
            color="#717171"
            @click.prevent="popupAccountGuide = false"
            class="btn-gray btn-block"
            >{{ this.$t("confirm.cancel") }}</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
          <vs-button
            color="primary"
            @click.prevent="
              (popupAccountGuide = false), (popupAccountAgree = true)
            "
            class="btn-block custom"
            type="filled"
            >유진투자증권 계좌 등록하러 가기</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- POPUP 계좌등록 안내//E -->
    <!-- POPUP 계좌인증 및 등록//S -->
    <vs-popup title="계좌 등록" :active.sync="popupAccountRegist">
      <h3>계좌 정보입력</h3>
      <vs-input
        label="예금주"
        class="input-block input-custom disable-custom"
        disabled="true"
        v-model="accountUserName"
      ></vs-input>
      <vs-input
        label="은행"
        class="input-block input-custom disable-custom"
        disabled="true"
        v-model="accountBankName"
        >유진투자증권</vs-input
      >
      <vs-input
        type="text"
        pattern="[0-9]*"
        inputmode="decimal"
        label="계좌번호"
        placeholder="하이픈 '-' 없이 숫자만 입력"
        class="input-block input-custom"
        v-model="accountBankNumber"
      ></vs-input>

      <div class="well well-black">
        <ul class="number-list">
          <li>
            실명확인 계좌는 본인명의의 유진투자증권 계좌 1개만 등록 가능합니다.
          </li>
          <li>
            KRW의 입금과 출금은 인증 및 등록 완료한 실명확인 계좌를 통해서만
            가능 합니다.
          </li>
          <li>
            FLYBIT에 본인인증 된 실명과 계좌 예금주 명의가 일치해야 합니다.
          </li>
          <li>
            은행 점검 시간에는 해당 계좌에 대한 인증이 지연 또는 불가능할 수
            있습니다.
          </li>
        </ul>
      </div>
      <vs-button
        color="primary"
        @click.prevent="accountRegist"
        class="btn-block custom"
        type="filled"
        >다음</vs-button
      >
    </vs-popup>
    <!-- POPUP 계좌 등록//E -->
    <!-- POPUP 이용약관//S -->
    <vs-popup title="이용약관" :active.sync="popupAccountAgree">
      <p class="text-left" v-html="bonanzaTerm"></p>
      <div class="account-regist-check clearfix">
        <vs-checkbox v-model="bankTermsAgree"
          >위 내용을 확인하고, 동의합니다.</vs-checkbox
        >
      </div>
      <vs-button
        color="primary"
        @click.prevent="bankAgreeHandler"
        class="btn-block custom"
        type="filled"
        >확인</vs-button
      >
    </vs-popup>
    <!-- POPUP 약관동의//E -->
    <!-- POPUP 계좌 인증//S -->
    <vs-popup title="계좌인증" :active.sync="popupAccountCertify">
      <h3>계좌 정보입력</h3>
      <div class="input-group">
        <vs-input
          type="text"
          pattern="[0-9]*"
          inputmode="decimal"
          label="계좌정보"
          placeholder="계좌정보"
          class="input-custom disable-custom"
          v-model="accountBankNumber"
          disabled="true"
        ></vs-input>
        <span class="input-group-btn">
          <vs-button
            color="#b5b5b5"
            size="small"
            class="btn-wide"
            type="filled"
            @click.prevent="doCorporatePossess"
            v-if="!send"
            >인증번호 발송</vs-button
          >
          <vs-button
            color="#b5b5b5"
            size="small"
            class="btn-wide"
            type="filled"
            v-else-if="remain"
            >{{ remain }}</vs-button
          >
          <vs-button
            color="#b5b5b5"
            size="small"
            class="btn-wide"
            type="filled"
            @click.prevent="doCorporatePossess"
            v-else
            >인증번호 재발송</vs-button
          >
        </span>
      </div>
      <vs-input
        label="입금자명"
        placeholder="숫자3자리입력"
        class="input-block input-custom"
        v-model="smsCode"
      ></vs-input>
      <div class="well well-black">
        <ul class="number-list">
          <li>
            계좌인증 버튼을 클릭 후 등록하신 계좌로 1원을 송금해 드립니다.
          </li>
          <li>입금자명 플라이빗 제외한 숫자 3자리만 입력하여 주세요.</li>
          <li>5회 이상 계좌 인증 실패 시 24시간 이후에 재시도 가능합니다.</li>
          <li>10분 이내 미 입력 시 계좌 인증 실패 1회로 인정됩니다.</li>
        </ul>
      </div>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
          <vs-button
            color="#717171"
            @click.prevent="popupAccountCertify = false"
            class="btn-gray btn-block"
            >취소</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
          <vs-button
            color="primary"
            @click="doRegisterAccount"
            class="btn-block custom"
            type="filled"
            >계좌 인증 및 등록</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- POPUP 계좌 인증//E -->
    <!-- POPUP 계좌 등록실패//S -->
    <vs-popup title="계좌 등록 실패 안내" :active.sync="popupAccountAuthFail">
      <p class="text-center">
        <span class="icon err"></span>
        <br />
        <strong>
          FLYBIT에 등록할 수 없는 계좌 입니다.
          <br />예금주와 계좌번호를 한번더 확인 부탁드립니다.
        </strong>
      </p>
      <p class="text-center">
        본인 인증과 동일한 예금주의
        <br />유진투자증권계좌만 등록 가능합니다.
      </p>
      <vs-button
        color="primary"
        @click.prevent="popupAccountAuthFail = false"
        class="btn-block custom"
        type="filled"
        >확인</vs-button
      >
    </vs-popup>
    <!-- POPUP 계좌 등록실패//E -->
    <!-- POPUP 계좌 등록실패 (5회)//S -->
    <vs-popup title="계좌 등록 실패 안내" :active.sync="popupAccountAuthFail5">
      <p class="text-center">
        <span class="icon err"></span>
        <br />
        <strong>
          계좌인증 5회 이상 실패하여
          <br />
          <span class="txt-blue">24시간 후에 재 인증 가능</span> 합니다.
        </strong>
      </p>
      <vs-button
        color="primary"
        @click.prevent="popupAccountAuthFail5 = false"
        class="btn-block custom"
        type="filled"
        >확인</vs-button
      >
    </vs-popup>
    <!-- POPUP 계좌 등록실패 (5회)//E -->
    <!-- POPUP 계좌 등록실패 (입금자명 불일치)//S -->
    <vs-popup
      title="계좌 등록 실패 안내"
      :active.sync="popupAccountAuthFailNotMatch"
    >
      <p class="text-center">
        <span class="icon err"></span>
        <br />
        <strong>입금자명 숫자가 일치하지 않습니다.</strong>
      </p>
      <p class="text-center">
        5회 이상 계좌 인증 실패 시
        <br />24시간 이후에 재시도 가능합니다.
      </p>
      <vs-button
        color="primary"
        @click.prevent="popupAccountAuthFailNotMatch = false"
        class="btn-block custom"
        type="filled"
        >확인</vs-button
      >
    </vs-popup>
    <!-- POPUP 계좌 등록실패 (입금자명 불일치)//E -->
    <!-- POPUP 계좌 인증완료//S -->
    <vs-popup title="계좌 인증 완료" :active.sync="popupAccountSuccess">
      <p class="text-center">
        <span class="icon success"></span>
        <br />
        <strong>계좌 인증 및 등록이 완료 되었습니다.</strong>
      </p>
      <p class="text-center">(유진투자증권 123-456-789)</p>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="#717171"
            @click.prevent="popupAccountSuccess = false"
            class="btn-gray btn-block"
            >확인</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click.prevent="$router.push({ name: 'Withdraw' })"
            class="btn-block custom"
            type="filled"
            >KRW 입금하기</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- POPUP 계좌 인증완료//E -->
    <!-- POPUP 계좌 인증해지//S -->
    <vs-popup title="계좌인증 해지" :active.sync="popupRemoveAccount">
      <p class="text-center">
        <strong>입출금 계좌 인증을 해지 하시겠습니까?</strong>
        <br />
        (유진투자증권 {{ accountNumber }})
      </p>
      <p class="text-center">
        FLYBIT의 입/출금 거래를 위해선
        <br />계좌 인증이 필수 입니다. <br />인증 등급이 레벨 2가 되어 출금
        한도가 하향됩니다.
      </p>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="#717171"
            @click.prevent="popupRemoveAccount = false"
            class="btn-gray btn-block"
            >취소</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click.prevent="doRemoveAccount"
            class="btn-block custom"
            type="filled"
            >확인</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- POPUP 계좌 인증해지//E -->
    <!-- POPUP 계좌 인증해지 완료//S -->
    <vs-popup title="계좌 해제 완료" :active.sync="popupRemoveAccountTrue">
      <p class="text-center">
        <span class="icon success"></span>
        <br />
        <strong>
          입출금 계좌 인증 해제가
          <br />완료 되었습니다.
        </strong>
      </p>
      <vs-button
        color="primary"
        @click.prevent="popupRemoveAccountTrue = false"
        class="btn-block custom"
        type="filled"
        >확인</vs-button
      >
    </vs-popup>
    <!-- POPUP 계좌 인증해지 완료//E -->
    <!-- POPUP 계좌 인증해지 실패//S -->
    <vs-popup title="계좌 해제 실패" :active.sync="popupRemoveAccountFalse">
      <p class="text-center">
        <span class="icon err"></span>
        <br />
        <strong>
          입출금 계좌 인증 해제가
          <br />실패하였습니다.
        </strong>
      </p>
      <vs-button
        color="primary"
        @click.prevent="popupRemoveAccountFalse = false"
        class="btn-block custom"
        type="filled"
        >확인</vs-button
      >
    </vs-popup>
    <!-- POPUP 계좌 인증해지 실패//E -->
    <!-- POPUP 모바일 입금불가//S -->
    <vs-popup :title="$t('unableMobile.title')" :active.sync="mobileFailPopup">
      <p class="text-center" v-html="$t('unableMobile.title')"></p>
      <vs-button
        color="primary"
        @click="mobileFailPopup = false"
        class="btn-block custom"
        type="filled"
        >확인</vs-button
      >
    </vs-popup>
    <!-- POPUP 모바일 입금불가//E -->
  </div>
</template>
<script>
import Api from "@/common/Api";
import { mapGetters } from "vuex";
import GlobalEvent from "@/common/Event";
import Moment from "moment";

export default {
  created() {
    if (this.bankConfirm) {
      this.bankName = this._.get(this.accounts, ["deposit", "bankName"], "");
      this.accountNumber = this._.get(
        this.accounts,
        ["deposit", "accountNumber"],
        ""
      );
    }

    this.accountUserName = this.userInfo.name;
    this.accountBankName = "유진투자증권";

    this.getUserPrivateInfo();
    // window.sendResult = this.recieveResult;

    // this.removeOTPModal = true
    // this.RemoveOTPModal();
    // this.residenceModal = true
    //this.ResidenceModal()
    Api.Setting.getBonanzaTerms().then(({ body }) => {
      this.bonanzaTerm = body.data;
    });
  },
  computed: {
    ...mapGetters([
      "userInfo",
      "authStep",
      "useOTP",
      "authLevel",
      "accounts",
      "authResidence",
    ]),
    emailConfirm() {
      return true;
    },
    userConfirm() {
      return this.authStep !== "E";
    },
    otpConfirm() {
      return this.useOTP;
    },
    otpDate() {
      return _.get(this, ["userInfo", "authInfo", "otpDate"], "");
    },
    bankConfirm() {
      return this.accounts.deposit !== null;
    },
    residenceConfirm() {
      return this.authResidence === "E" ? true : false;
    },
  },
  data() {
    return {
      mobileFailPopup: false,
      necessaryCertifiaction: false,
      removeOTPModal: false,
      phone: "",
      email: "",
      otpNumber: "",
      popupMinorRefuse: false,
      popupAccountGuide: false,
      popupAccountRegist: false,
      popupAccountAgree: false, // 이용약관,
      bankTermsAgree: false,
      bankName: "",
      accountNumber: "",
      accountUserName: "",
      accountBankName: "",
      accountBankNumber: "",
      bonanzaTerm: "",
      popupAccountCertify: false,
      popupAccountAuthFail: false,
      popupAccountAuthFail5: false,
      popupAccountAuthFailNotMatch: false,
      popupAccountSuccess: false,
      popupRemoveAccount: false,
      popupRemoveAccountTrue: false,
      popupRemoveAccountFalse: false,

      intervalId: "",
      remain: "00:00",
      expire: +Moment().add(10, "minutes"),
      send: false,
      smsCode: "",
    };
  },
  methods: {
    remainTime() {
      const remain = Moment(+this.expire - +Moment());
      if (+remain > 0) {
        this.remain = remain.format("mm:ss");
      } else {
        clearInterval(this.intervalId);
        this.remain = false;
      }
    },
    doCorporatePossess() {
      this.$vs.loading();
      Api.User.doCorporatePossess({
        bankCode: "280",
        accountNumber: this.accountBankNumber,
        deviceType: this.$deviceType(),
      })
        .then((response) => {
          this.expire = +Moment().add(10, "minutes");
          this.remainTime();
          this.intervalId = setInterval(this.remainTime, 1000);
          this.send = true;
        })
        .catch((e) => {
          this.$vs.notify({
            title: "안내",
            text: "서버에러 입니다.<br>고객센터에 문의 바랍니다.",
            color: "danger",
            position: "top-right",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    accountRegist() {
      if (!this.accountBankNumber) {
        this.$vs.notify({
          title: "안내",
          text: "계좌번호를 입력해주세요.",
          color: "danger",
          position: "top-right",
        });
        return false;
      }

      this.$vs.loading();
      Api.User.registAccount({
        bankCode: "280",
        accountNumber: this.accountBankNumber,
      })
        .then((response) => {
          this.popupAccountRegist = false;
          this.popupAccountCertify = true;
          // this.accountNumber = this.accountBankNumber;
        })
        .catch((e) => {
          // console.log(e)
          const ErrorCode = _.get(
            e,
            ["response", "data", "result", "code"],
            "0000"
          );
          switch (ErrorCode) {
            case "0000":
              this.$vs.notify({
                title: "안내",
                text: "서버에러 입니다.<br>고객센터에 문의 바랍니다.",
                color: "danger",
                position: "top-right",
              });
            default:
              // this.popupAccountAuthFail = true;
              this.$vs.notify({
                title:
                  "FLYBIT에 등록할 수 없는 계좌 입니다.<br>예금주와 계좌번호를 한번더 확인 부탁드립니다.",
                text:
                  "본인 인증과 동일한 예금주의<br>유진투자증권계좌만 등록 가능합니다.",
                color: "danger",
                position: "top-right",
              });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    bankAgreeHandler() {
      if (this.bankTermsAgree) {
        this.popupAccountAgree = false;
        this.popupAccountRegist = true;
      } else {
        this.$vs.notify({
          title: "안내",
          text: "계좌개설 이용약관에 동의해 주세요.",
          color: "danger",
          position: "top-right",
        });
      }
    },
    RemoveOTPModal() {
      var text = `
        <p class='text-center'>
          해지 후 출금 한도가 하향됩니다.<br>
          OTP 인증번호 <vs-input type="text" pattern="[0-9]*" inputmode="decimal" class="input-otp" placeholder="숫자 6자리" v-model="otpNumber"></vs-input><br>
          입출금 OTP인증 서비스를 해지 하시겠습니까?
        </p>`;
      this.$ev.$emit("popup", {
        css: "text-center",
        title: "OTP 인증 해지",
        content: text,
        hasHTML: true,
        buttons: [
          {
            type: "CANCEL",
            text: this.$t("confirm.cancel"),
            closeOnClick: true,
          },
          {
            type: "OK",
            text: this.$t("confirm.ok"),
            onClick: () => {
              this.otpDelete();
            },
          },
        ],
      });
    },
    doAppDnSms() {
      Api.Aspect.doAppDnSms()
        .then((response) => {
          this.$vs.notify({
            title: "SMS발송",
            text: "발송되었습니다.",
            position: "top-left",
          });
        })
        .catch((e) => {});
    },
    PopupMinorRefuse() {
      var text =
        "<p class='text-center'>죄송합니다. 미성년자(만 19세 미만) 또는<br>외국인(국내 비거주자)은 본인인증을 진행할 수 없습니다.</p>";
      this.$ev.$emit("popup", {
        title: "서비스 이용제한 안내",
        content: text,
        hasHTML: true,
      });
    },
    ResidenceModal() {
      var text =
        "<p class='text-center'>현재 FLYBIT 운영자가 거주지 증명을 위한 인증서류를 확인 중입니다.<br>인증서류의 재등록 시 거주지 증명 또한 다시 신청되기 때문에<br>인증 완료까지 추가 기간이 발생될 수 있습니다.</p>";
      this.$ev.$emit("popup", {
        title: "거주지 등록",
        content: text,
        hasHTML: true,
        buttons: [
          {
            type: "CANCEL",
            text: "취소",
            closeOnClick: true,
          },
          {
            type: "OK",
            text: "재등록",
            onClick: () => {
              this.goResidence();
            },
          },
        ],
      });
    },
    getUserPrivateInfo() {
      this.$store.dispatch("updateUserInfo");
      Promise.all([
        Api.User.getUserPrivateInfo("email"),
        Api.User.getUserPrivateInfo("phone"),
      ]).then(([email, phone]) => {
        this.email = email.body.data;
        this.phone = phone.body.data;
      });
    },

    otpUpdate() {
      if (this.authLevel < 2 || !this.phone || this.phone === "") {
        this.notiNotAllowed("본인인증");
        return false;
      }
      if (this.otpConfirm) {
        this.removeOTPModal = true;
      } else {
        this.$router.push({ name: "OtpConfirm" });
      }
    },
    otpDelete() {
      if (this.otpValid()) {
        Api.User.terminateOTP(this.otpNumber)
          .then((response) => {
            this.$vs.notify({
              duration: 3000,
              title: "완료",
              type: "warning",
              text: "OTP 설정이 해제 되었습니다.",
              customClass: "FLYBIT-noti",
              position: "top-left",
            });
            this.removeOTPModal = false;
            this.getUserPrivateInfo();
            //
            // this.$refs.otpForm.resetFields();
          })
          .catch((e) => {
            this.failNoti("인증번호가 잘못되었습니다.", "인증");
            this.otpNumber = "";
          });
      }
    },
    otpValid() {
      if (!this.otpNumber) {
        this.failNoti("인증번호를 입력해주세요.", "인증");
        return false;
      }
      return true;
    },
    failNoti(text, title) {
      this.$vs.notify({
        title,
        text,
        position: "top-right",
        color: "danger",
      });
    },
    authPhone() {
      window.open(
        `${Api.Comm.url}auth/realnameView`,
        "chkPopup",
        "width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no"
      );
    },
    residence() {
      if (this.authLevel < 2) {
        this.notiNotAllowed("본인인증");
        return false;
      }
      if (!this.useOTP) {
        this.notiNotAllowed("OTP 인증");
        return false;
      }
      if (this.authResidence == "R") {
        // this.residenceModal = true;
        this.ResidenceModal();
        return false;
      }
      if (this.residenceConfirm) {
        return false;
      }
      this.goResidence();
    },
    goResidence() {
      //this.residenceModal = false
      setTimeout(() => {
        this.$router.push({ name: "MypageResidence" });
      }, 50);
    },

    notiNotAllowed(step) {
      this.$vs.notify({
        title: "인증센터",
        text: `먼저 ${step}을 완료하세요.`,
        type: "warning",
        customClass: "FLYBIT-noti",
        position: "top-left",
      });
    },
    // recieveResult(result) {
    //   Api.User.getAuthResult()
    //     .then((_res) => {
    //       const resultStat = _.get(_res, ["body", "successful"], "");
    //       this.authFailMsg = _.get(
    //         _res,
    //         ["body", "msg"],
    //         "본인인증에 실패했습니다."
    //       );
    //       switch (resultStat.toUpperCase()) {
    //         case "S":
    //           // 인증 성공
    //           this.$vs.notify({
    //             title: "인증 성공",
    //             text: "본인 인증에 성공했습니다.",
    //             type: "warning",
    //           });
    //           break;
    //         case "M":
    //         case "I":
    //           // 미성년자, 외국인
    //           // this.popupMinorRefuse = true;
    //           this.PopupMinorRefuse();
    //           break;
    //         default:
    //           // 인증 실패
    //           this.failNoti(this.authFailMsg, "인증실패");
    //           break;
    //       }

    //       this.getUserPrivateInfo();
    //     })
    //     .catch((e) => {
    //       this.authFailMsg = "본인인증에 실패했습니다.";
    //       this.$alert(this.authFailMsg);
    //       this.getUserPrivateInfo();
    //     });
    // },
    accountAuth() {
      this.mobileFailPopup = true;
      return false;

      if (this.bankConfirm) {
        this.popupRemoveAccount = true;
        return false;
      }

      if (this.authLevel < 2 || !this.phone || this.phone === "") {
        this.notiNotAllowed("본인인증");
        return false;
      } else {
        Api.Aspect.getAccountFailCount()
          .then((response) => {
            this.popupAccountGuide = true;
          })
          .catch((e) => {
            const count = _.get(e, ["response", "data", "result", "cnt"], 0);
            if (count >= 5) {
              this.popupAccountAuthFail5 = true;
            } else {
              this.$alert("서버에러입니다.");
            }
          });
      }
    },
    //this.$ev.$emit('loading', false);
    doRemoveAccount() {
      this.$vs.loading();
      Api.User.doRegisterAccount({
        procType: 2,
        code: "000",
        bankCode: "280",
        accountNumber: this.accounts.deposit.accountNumber,
        deviceType: this.$deviceType(),
      })
        .then((response) => {
          this.popupRemoveAccount = false;
          this.popupRemoveAccountTrue = true;

          this.accountNumber = "";
          this.$store.dispatch("updateUserInfo");
        })
        .catch((e) => {
          this.popupRemoveAccountFalse = true;
        })
        .finally(() => {
          //this.popupRemoveAccount = false;
          this.$vs.loading.close();
        });
    },
    doRegisterAccount() {
      if (!this.smsCode) {
        this.$vs.notify({
          title: "안내",
          text: "인증번호를 입력해주세요.",
          color: "danger",
          position: "top-right",
        });
        return false;
      }

      this.$vs.loading();
      Api.User.doRegisterAccount({
        procType: 1,
        code: this.smsCode,
        bankCode: "280",
        accountNumber: this.accountBankNumber,
        deviceType: 200,
      })
        .then((response) => {
          this.popupAccountSuccess = true;
          this.popupAccountCertify = false;
          this.$store.dispatch("updateUserInfo");
          this.bankName = "유진투자증권";
          this.accountNumber = this.accountBankNumber;
        })
        .catch((e) => {
          this.$vs.notify({
            title:
              "FLYBIT에 등록할 수 없는 계좌 입니다.<br>예금주와 계좌번호를 한번더 확인 부탁드립니다.",
            text:
              "본인 인증과 동일한 예금주의<br>유진투자증권계좌만 등록 가능합니다.",
            color: "danger",
            position: "top-right",
          });
        })
        .finally(() => {
          //this.popupAccountCertify = false;
          this.$vs.loading.close();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
body button {
  padding: 4px 0;
}
.certification-row {
  position: relative;
  .data-box {
    width: calc(100% - 160px);
  }
  > .btn-agree-view {
    &.bank-btn {
      position: relative;
      right: 0px;
    }
  }
}
.btn-wide {
  width: 100px;
}
</style>
